import { useMutation, useQuery } from "@tanstack/react-query"

import { useLocalesState } from "../../shared/context/locales"
import { useSDK } from "../../shared/context/client"

const useQueryContactCategories = () => {
    const client = useSDK()
    const { language } = useLocalesState()

    return useQuery({
        queryKey: ["getContactCategories"],
        queryFn: ({ signal }) => client.getContactCategories(language, signal),
        meta: { errorToast: true },
    })
}

const usePostContact = () => {
    const client = useSDK()

    return useMutation({ mutationFn: body => client.postContact(body) })
}

export { useQueryContactCategories, usePostContact }
